import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { bind } from '../Utils/Bind';

export interface ICardItemProps {
    readonly className?: string;
    readonly header?: boolean;
    readonly label: string;
    readonly value: React.ReactNode;
    readonly dontRenderOnFalseValue?: boolean;
}

@observer
export class CardItem extends React.Component<ICardItemProps> {
    public render() {
        if (this.props.dontRenderOnFalseValue && !this.props.value) return null;

        return (
            <div className={this.props.className + ' card-item'}>
                <div className="container-fluid px-3 py-2">
                    <div className="row">
                        <div className="col-6 pe-0">
                            <div className="d-table h-100 w-100">
                                {this.props.header && (
                                    <div className="card-item-label fw-bold py-1 border-bottom">{this.props.label}</div>
                                )}

                                {!this.props.header && <div className="card-item-label">{this.props.label}</div>}
                            </div>
                        </div>

                        <div className="col-6 text-end">{this.props.value ?? '-'}</div>
                    </div>
                </div>
            </div>
        );
    }
}
